import { HTTP_INTERCEPTORS, HttpBackend, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { UrlSerializer, provideRouter } from '@angular/router';
import { SpinnerInterceptor } from '@enliven/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { routes } from './app.routes';
import { LowerCasePathSerializer } from './classes/lower-case-path-serializer';
import { AuthInterceptor } from './interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (_httpBackend: HttpBackend) =>
            new MultiTranslateHttpLoader(_httpBackend, [
              './assets/i18n/api-errors/', // api errors first, so regular errors can override
              './assets/i18n/common/', // shared common translations being used
              './assets/i18n/'
            ]),
          deps: [HttpBackend]
        }
      })
    ),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    { provide: UrlSerializer, useClass: LowerCasePathSerializer },
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi())
  ]
};
